import { useRef } from 'react';

export const useRefCtx = <T>(t: T) => {
  const ref = useRef<T>();
  ref.current = t;
  return ref;
};
